import * as React from 'react';
import * as _ from 'lodash';
import { PARTS } from './../../schemas/accessRightsModel';
import classNames from 'classnames';
import { VISUALIZER_TYPES } from '../../constants/dashboard';
export default function () {
    function onClick1(mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex) {
        this.handleSwapBVPlaces(mobileBVMenuLinkIndex, mobileBVMenuLinkIndex - 1);
    }
    function onClick2(mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex) {
        this.handleSwapBVPlaces(mobileBVMenuLinkIndex, mobileBVMenuLinkIndex + 1);
    }
    function onChange3(mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex, e) {
        this.handleChangeBVLink(e, 'name', mobileBVMenuLinkIndex);
    }
    function onChange4(mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex, e) {
        this.handleChangeBVLink(e, 'url', mobileBVMenuLinkIndex);
    }
    function onClick5(mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex) {
        this.handleDeleteBVLink(mobileBVMenuLinkIndex);
    }
    function repeatMobileBVMenuLink6(mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex) {
        return React.createElement('li', {
            'className': 'visualizer-menu-list__item',
            'key': mobileBVMenuLinkIndex
        }, React.createElement('div', { 'className': 'visualizer-menu-list__item-row' }, React.createElement('div', { 'className': 'visualizer-menu-cell visualizer-menu-cell--sort visualizer-menu-sort' }, mobileBVMenuLinkIndex !== 0 ? React.createElement('span', {
            'className': 'visualizer-menu-sort__up',
            'onClick': onClick1.bind(this, mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex),
            'key': '996'
        }) : null, React.createElement('span', { 'className': 'visualizer-menu-sort__number' }, mobileBVMenuLinkIndex + 1), mobileBVMenuLinkIndex !== mobileBVMenu.length - 1 ? React.createElement('span', {
            'className': 'visualizer-menu-sort__down',
            'onClick': onClick2.bind(this, mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex),
            'key': '1292'
        }) : null), React.createElement('div', { 'className': 'visualizer-menu-cell visualizer-menu-cell--name' }, React.createElement('div', { 'className': 'ui-input-block' }, React.createElement('label', {
            'htmlFor': 'linkname' + mobileBVMenuLinkIndex,
            'className': 'ui-input-block__label'
        }, 'Link Name'), React.createElement('input', {
            'type': 'text',
            'id': 'linkname' + mobileBVMenuLinkIndex,
            'className': 'ui-input-block__input',
            'placeholder': 'Enter link name',
            'value': mobileBVMenuLink.name,
            'onChange': onChange3.bind(this, mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex)
        }))), React.createElement('div', { 'className': 'visualizer-menu-cell' }, React.createElement('div', { 'className': 'ui-input-block' }, React.createElement('label', {
            'htmlFor': 'url' + mobileBVMenuLinkIndex,
            'className': 'ui-input-block__label'
        }, 'Url'), React.createElement('input', {
            'type': 'text',
            'id': 'url' + mobileBVMenuLinkIndex,
            'className': 'ui-input-block__input',
            'placeholder': 'Enter url',
            'value': mobileBVMenuLink.url,
            'onChange': onChange4.bind(this, mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex)
        }))), React.createElement('div', { 'className': 'visualizer-menu-cell' }, AR.e(PARTS.VIS_MNGM_NEW_LINKS) ? React.createElement('button', {
            'className': 'users-sites-remove__button ui-icon-remove',
            'onClick': onClick5.bind(this, mobileMenu, mobileBVMenu, AR, mobileBVMenuLink, mobileBVMenuLinkIndex),
            'key': '2616'
        }) : null)));
    }
    function onClick7(mobileMenu, mobileBVMenu, AR) {
        AR.e(PARTS.VIS_MNGM_NEW_LINKS) && this.handleAddBVLink();
    }
    function onClick8(mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex) {
        this.handleSwapPlaces(mobileMenuLinkIndex, mobileMenuLinkIndex - 1);
    }
    function onClick9(mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex) {
        this.handleSwapPlaces(mobileMenuLinkIndex, mobileMenuLinkIndex + 1);
    }
    function onChange10(mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex, e) {
        this.handleChangeLink(e, 'name', mobileMenuLinkIndex);
    }
    function onChange11(mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex, e) {
        this.handleChangeLink(e, 'url', mobileMenuLinkIndex);
    }
    function onClick12(mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex) {
        this.handleDeleteLink(mobileMenuLinkIndex);
    }
    function repeatMobileMenuLink13(mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex) {
        return React.createElement('li', {
            'className': 'visualizer-menu-list__item',
            'key': mobileMenuLinkIndex
        }, React.createElement('div', { 'className': 'visualizer-menu-list__item-row' }, React.createElement('div', { 'className': 'visualizer-menu-cell visualizer-menu-cell--sort visualizer-menu-sort' }, mobileMenuLinkIndex !== 0 ? React.createElement('span', {
            'className': 'visualizer-menu-sort__up',
            'onClick': onClick8.bind(this, mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex),
            'key': '3684'
        }) : null, React.createElement('span', { 'className': 'visualizer-menu-sort__number' }, mobileMenuLinkIndex + 1), mobileMenuLinkIndex !== mobileMenu.length - 1 ? React.createElement('span', {
            'className': 'visualizer-menu-sort__down',
            'onClick': onClick9.bind(this, mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex),
            'key': '3970'
        }) : null), React.createElement('div', { 'className': 'visualizer-menu-cell visualizer-menu-cell--name' }, React.createElement('div', { 'className': 'ui-input-block' }, React.createElement('label', {
            'htmlFor': 'linkname' + mobileMenuLinkIndex,
            'className': 'ui-input-block__label'
        }, 'Link Name'), React.createElement('input', {
            'type': 'text',
            'id': 'linkname' + mobileMenuLinkIndex,
            'className': 'ui-input-block__input',
            'placeholder': 'Enter link name',
            'value': mobileMenuLink.name,
            'onChange': onChange10.bind(this, mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex)
        }))), React.createElement('div', { 'className': 'visualizer-menu-cell' }, React.createElement('div', { 'className': 'ui-input-block' }, React.createElement('label', {
            'htmlFor': 'url' + mobileMenuLinkIndex,
            'className': 'ui-input-block__label'
        }, 'Url'), React.createElement('input', {
            'type': 'text',
            'id': 'url' + mobileMenuLinkIndex,
            'className': 'ui-input-block__input',
            'placeholder': 'Enter url',
            'value': mobileMenuLink.url,
            'onChange': onChange11.bind(this, mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex)
        }))), React.createElement('div', { 'className': 'visualizer-menu-cell' }, AR.e(PARTS.VIS_MNGM_NEW_LINKS) ? React.createElement('button', {
            'className': 'users-sites-remove__button ui-icon-remove',
            'onClick': onClick12.bind(this, mobileMenu, mobileBVMenu, AR, mobileMenuLink, mobileMenuLinkIndex),
            'key': '5264'
        }) : null)));
    }
    function onClick14(mobileMenu, mobileBVMenu, AR) {
        AR.e(PARTS.VIS_MNGM_NEW_LINKS) && this.handleAddLink();
    }
    function scopeMobileMenuMobileBVMenuAR15() {
        var mobileMenu = this.props.mobileMenu;
        var mobileBVMenu = this.props.mobileBVMenu;
        var AR = this.props.AR;
        return React.createElement('div', {
            'className': 'visualizer-management-cell',
            'key': '237'
        }, this.props.hasBathroom ? React.createElement('div', {
            'className': 'ui-title ui-title--gray',
            'key': '487'
        }, 'Mobile Navigation Bathroom Visualizer Menu') : null, this.props.hasBathroom ? React.createElement('div', {
            'className': 'visualizer-menu',
            'key': '607'
        }, React.createElement.apply(this, [
            'ul',
            { 'className': 'visualizer-menu-list' },
            _.map(mobileBVMenu, repeatMobileBVMenuLink6.bind(this, mobileMenu, mobileBVMenu, AR))
        ]), React.createElement('button', {
            'className': 'visualizer-menu-button',
            'onClick': onClick7.bind(this, mobileMenu, mobileBVMenu, AR)
        }, React.createElement('span', { 'className': 'visualizer-menu-button__text' }, '+ Add mobile link'))) : null, this.props.hasBathroom && this.props.hasKitchen ? React.createElement('div', {
            'className': 'visualizer-management-divider',
            'key': '3079'
        }) : null, this.props.hasKitchen ? React.createElement('div', {
            'className': 'ui-title ui-title--gray',
            'key': '3184'
        }, 'Mobile Navigation Kitchen Visualizer Menu') : null, this.props.hasKitchen ? React.createElement('div', {
            'className': 'visualizer-menu',
            'key': '3302'
        }, React.createElement.apply(this, [
            'ul',
            { 'className': 'visualizer-menu-list' },
            _.map(mobileMenu, repeatMobileMenuLink13.bind(this, mobileMenu, mobileBVMenu, AR))
        ]), React.createElement('button', {
            'className': 'visualizer-menu-button',
            'onClick': onClick14.bind(this, mobileMenu, mobileBVMenu, AR)
        }, React.createElement('span', { 'className': 'visualizer-menu-button__text' }, '+ Add mobile link'))) : null);
    }
    return this.props.AR.v(PARTS.VIS_MNGM_NEW_LINKS) ? scopeMobileMenuMobileBVMenuAR15.apply(this, []) : null;
}